/**
 * Brand service-book matching for a vehicle card (#2201).
 *
 * The manufacturer portal is stored on the make, with an optional model-year
 * range. The vehicle card is where year is known, so relevance is decided here
 * rather than on the make list.
 */

export function makeKey(value: string): string {
  return value.trim().toLowerCase();
}

export function findMakeEntry<T extends { make: string }>(
  makes: T[] | undefined,
  make: string | null | undefined,
): T | undefined {
  if (makes == null || make == null || make.trim() === '') return undefined;
  const key = makeKey(make);
  return makes.find((item) => makeKey(item.make) === key);
}

export function isMakeServiceBookRelevant(
  settings: {
    serviceBookUrl: string | null;
    serviceBookYearFrom: number | null;
    serviceBookYearTo: number | null;
  } | null | undefined,
  year: number | null | undefined,
): boolean {
  if (settings?.serviceBookUrl == null || settings.serviceBookUrl === '') return false;
  const from = settings.serviceBookYearFrom;
  const to = settings.serviceBookYearTo;
  if (year == null) return from == null && to == null;
  if (from != null && year < from) return false;
  if (to != null && year > to) return false;
  return true;
}

/** "2019–2026", "2019–", or null when the book has no year bounds. */
export function formatServiceBookYearRange(
  from: number | null,
  to: number | null,
): string | null {
  if (from == null && to == null) return null;
  if (from != null && to != null) return from === to ? String(from) : `${from}–${to}`;
  return from != null ? `${from}–` : `–${to ?? ''}`;
}
